import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import Segment from './Segment';
import '../styles/segment-flair.css';

const SegmentDemo = () => {
  // Handler for flair actions in demo
  const handleFlairAction = (action, segmentType) => {
    alert(`Action: ${action} on segment type: ${segmentType}`);
  };

  // Handler for delete action in demo
  const handleDelete = () => {
    alert('Delete action triggered');
  };

  return (
    <Box sx={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px' }}>
        Segment Component Demo
      </Typography>
      
      <Stack spacing={3}>
        <Box>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Default Segment (red border)
          </Typography>
          <Segment>
            Phase
          </Segment>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Segments with Flairs
          </Typography>
          <Stack spacing={2}>
            <Segment 
              borderColor="#00A9E0" 
              segmentType="text typing animation"
              onFlairAction={handleFlairAction}
              onDelete={handleDelete}
              isSelected={true}
              isExpanded={true}
            >
              Text Typing Animation
            </Segment>
            <Segment 
              borderColor="#92C911" 
              segmentType="icon entrance animation"
              onFlairAction={handleFlairAction}
              onDelete={handleDelete}
              isExpanded={true}
            >
              Icon Entrance Animation
            </Segment>
            <Segment 
              borderColor="#E87722" 
              segmentType="finale animation"
              onFlairAction={handleFlairAction}
              onDelete={handleDelete}
              isExpanded={true}
            >
              Finale Animation
            </Segment>
          </Stack>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Custom Border Colors
          </Typography>
          <Stack spacing={2}>
            <Segment borderColor="#00A9E0">
              Primary Phase
            </Segment>
            <Segment borderColor="#92C911">
              Secondary Phase
            </Segment>
            <Segment borderColor="#E87722">
              Text Phase
            </Segment>
            <Segment borderColor="#CE0F69">
              Background Phase
            </Segment>
          </Stack>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Custom Content
          </Typography>
          <Segment borderColor="#9c27b0">
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Custom Content with Bold Text
            </Typography>
          </Segment>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Multiple Segments in a Row
          </Typography>
          <Stack direction="row" spacing={2}>
            <Segment borderColor="#f44336">Phase 1</Segment>
            <Segment borderColor="#2196f3">Phase 2</Segment>
            <Segment borderColor="#4caf50">Phase 3</Segment>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default SegmentDemo;
